<template functional>
  <span class="dataset-money">
    {{ $options.enable(props) }}
  </span>
</template>

<script>
import IMask from 'imask'
import ModuleBase from './module-base'

// mask adapter


export default {
  name: 'Money',
  mixins: [ModuleBase],
  // face
  enable: (props) => {
    // if(props.value < 999){
    
    //   return `$` + mask.resolve(String(props.value ))
    // }
    // if(props.value > 999 && props.value < 9999){
    //   return `$` + mask.resolve(String(props.value / 100))
    // }
    // if(props.value > 9999){
    //   return `$` + mask.resolve(String(props.value / 1000 ))
    // }
    const mask = IMask.createMask({
      mask: Number, // enable number mask

      // other options are optional with defaults below
      scale: props.value < 1000 ? 0 : props.value > 1000 ? 3 : 0, // digits after point, 0 for integers
      signed: false, // disallow negative
      thousandsSeparator: ',', // any single char
      padFractionalZeros: true, // if true, then pads zeros at end to the length of scale
      normalizeZeros: false, // appends or removes zeros at ends
      radix: props.value < 1000 ? " " : ',', // fractional delimiter
      mapToRadix: [',','.'], // symbols to process as radix

      // additional number interval options (e.g.)
      // min: -10000,
      // max: 10000
    })
    if(props.value === ""){
      props.value = 0
    }
    
    
    else{
     return `$` + mask.resolve(String(Number(props.value).toFixed()))
    }
  },
}
</script>

<style lang="scss">
@import '@/style/inject';

.dataset-money {
  color: #363636;
  font-weight: $weight-medium;
}
</style>
